import { APIRequest } from "@companion-core/shared/app/Interfaces/API";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { getRequestSubject } from "@companion-core/shared/app/Utils/myRequests";

export const useRequestCard = (data: APIRequest) => {
  const { t, i18n } = useTranslation();
  const location = useMemo(() => data["start_location"] ?? data["location"], [data]);
  const endLocation = useMemo(() => data["end_location"], [data]);
  const exists = (key: string): boolean => i18n.exists(key);
  const subject = getRequestSubject(t, exists, data.family, data.sub_family);
  const detailTitle: string = useMemo(() => {
    if (endLocation?.city && location?.city !== endLocation?.city) {
      return location?.city && endLocation?.city
        ? t("request.my-requests.subject.double-location.template", {
            subject,
            startLocation: location?.city,
            endLocation: endLocation?.city,
          })
        : subject;
    }
    return location?.city
      ? t("request.my-requests.subject.single-location.template", {
          subject,
          location: location?.city,
        })
      : subject;
  }, [location, endLocation, data, t]);

  return {
    detailTitle,
  };
};
